import createAPIServices  from './createAPIServices'

const api = createAPIServices()

export const getListRoles = (page_number = 1, page_size = 30) => {
    return api.makeAuthRequest({
        url: `/roles?page_number=${page_number}&page_size=${page_size}`,
        method: 'GET'
    })
}

export const createRole = role => {
    const json = JSON.stringify(role)

    return api.makeAuthRequest({
        url: `/roles`,
        method: 'POST',
        data: json,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const getRoleById = rid => {
    return api.makeAuthRequest({
        url: `/roles/${rid}`,
        method: 'GET'
    })
}

export const updateRoleById = (rid, role) => {
    const json = JSON.stringify(role)

    return api.makeAuthRequest({
        url: `/roles/${rid}`,
        method: 'PUT',
        data: json,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const deleteRole = rid => {
    return api.makeAuthRequest({
        url: `/roles/${rid}`,
        method: 'DELETE'
    })
}

export const getListActions = (page_number = 1, page_size = 100) => {
    return api.makeAuthRequest({
        url: `/roles/actions?page_number=${page_number}&page_size=${page_size}`,
        method: 'GET'
    })
}

export const getListActionByRoleId = rid => {
    return api.makeAuthRequest({
        url: `/roles/${rid}/actions`,
        method: 'GET'
    })
}

export const checkRoleName = role_name => {
    return {
        
    }
}